   <div class="wccard d-flex justify-content-between mb-1 px-2 py-2 talentCountFixonScroll" *ngIf="!currentURL.includes('talent-insights')">
            <div class="d-flex align-items-center four-matrix" style="background-color: #f2f2f2; cursor: default; width: 100%;">
                <div *ngIf="!totalCandidatesCountAvailable" class="text-center">
                  <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
                </div>
                <div *ngIf="totalCandidatesCountAvailable">
                    <span class="f-26 font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
                    <p class="text-9696 f-12 mb-0">Talent Count</p>
                </div>
            </div>
          <div class="d-flex align-items-center four-matrix" style="background-color: #f2f2f2; cursor: default; width: 100%;">
                <div *ngIf="!medianTenureInCountAvailable" class="text-center">
                  <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="median tenure">
                </div>
                <div *ngIf="medianTenureInCountAvailable">
                    <span class="f-26 font-weight-600" [innerHTML]="getFormattedTenureForMatrix(totalMedianTanureCount)"></span>
                    <p class="f-12 mb-0">Median Tenure <i class="fas fa-info-circle" matTooltip='Median Tenure of the talent' [matTooltipClass]="{ 'big-tooltip text-black': true }"></i></p>
                </div>
            </div>

            <div class="d-flex align-items-center align-items-center diversity-matrix" style="width: 100%;">
                <div *ngIf="!genderDataAvailable" class="text-center" style="margin-top: 6px;">
                    <img src="../../assets/rolling-loader.gif" style="width: 16%;" alt="">
                </div>
                <div class="d-flex" style="width: 100%; height:100%" *ngIf="genderDataAvailable">
                    <div class="gender-ratio pl-1" [ngStyle]="{'background-color': isMaleMatrixSelected ? '#f2f2f2' : ''}" (click)="malePercent && onClickMatrix('Male')">
                            <div class="gender">
                                <i class="fas fa-male text-9696 f-20"></i>
                                <span class="f-26 font-weight-600 pl-2 pr-1" >{{malePercent}}</span>
                                <span class="f-18 font-weight-500">%</span>
                            </div>
                            <p class="f-12 text-center mb-0">Men</p>
                    </div>
                    <div class="male-box mt-1 text-9696 pt-2"> | </div>
                    <div class ="gender-ratio pr-1" [ngStyle]="{'background-color': isFemaleMatrixSelected ? '#f2f2f2' : ''}" (click)="femalePercent && onClickMatrix('Female')">
                        <div class="gender">
                            <i class="fas fa-female text-9696 f-20"></i>
                            <span class="f-26 font-weight-600 female-box pl-2 pr-1" >{{femalePercent}}</span>
                            <span class="f-18 font-weight-500">%</span>
                        </div>
                        <p class="f-12 text-center mb-0">Women</p>
                    </div>
                </div>
                <!-- <span class="text-9696 f-12">Gender Diversity</span> -->
            </div>
         <div class="d-flex align-items-center four-matrix" [ngStyle]="{'background-color': isChangedJobsSelected ? '#f2f2f2' : ''}" (click)="changedJobs && onClickMatrix('changedJobs')">
            <div *ngIf="!changedJobsCountAvailable" class="text-center">
                <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="changedJobs">
            </div>
            <div *ngIf="changedJobsCountAvailable">
                <span class="f-26 font-weight-600">{{formatNumberToIndianFormat(changedJobs)}}</span>
                <p class=" f-12 mb-0" >Changed Jobs(past 1yr)</p>
            </div>
      </div>

        </div>

<div class="wccard p-3">
  <!-- Talent Distribution -->
  <div class="">
    <p class="f-16 font-weight-600 mb-1"> Where is the talent located?</p>
    <div class="row align-items-center">
      <div class="col-7">
        <div id="workCountryChartDD"
          [hidden]="!(personInsightsData?.dataSourceWorkCountry && personInsightsData?.dataSourceWorkCountry?.length)"
          *ngIf="personInsightsData?.dataSourceWorkCountry?.length" style="width: auto;"></div>
        <div class="loader text-center" *ngIf="!personInsightsData?.dataSourceWorkCountry?.length">
          <img *ngIf="personInsightsData.dataSourceWorkCountry" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.dataSourceWorkCountry?.length == 0">No Data Available for map highlights</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.topLocations?.length">
          <img *ngIf="!personInsightsData.topLocations" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.topLocations?.length == 0">No data available for top location</span>
        </div>
        <ng-container *ngIf="personInsightsData?.topLocations">
          <div class="d-flex flex-column" *ngFor="let location of personInsightsData?.topLocations?.slice(0,5)">
            <div class="d-flex align-items-center justify-content-between">
              <div class="text-truncate">{{location.key | titlecase}}</div>
              <div class=" font-weight-600">
                <span class="pointer" (click)="handleRedirection('location', location)">
                  {{location.doc_count | number}}
                </span>
              </div>
            </div>
            <hr class="HR-seperator-in-card mb-4 mx-0">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="HR-seperator-in-card mb-4">

  <!-- Top Companies - Industries -->
  <p class="f-16 font-weight-600 mb-1"> Which companies and industries are employing this talent?</p>
  <div class="row mb-2">
    <div class="col">
      <div class="row mb-3 mt-3">
        <div class="col-md-9 f-12 text-9696">
          Top Companies
        </div>
        <div class="col f-12 text-9696">
          Talent Count
        </div>
      </div>
      <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.dataSourceCurrentCompany?.data?.length">
        <img *ngIf="!personInsightsData.dataSourceCurrentCompany" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length == 0">No Data Available</span>
      </div>
      <div id="top1">
        <ng-container *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length">
          <div class="row mb-2" *ngFor="let item of personInsightsData?.dataSourceCurrentCompany?.data | slice:0:5">
            <div class="col-md-9">
              <div class="d-flex p-2 w-100 align-items-center">
                <div style="width: 50px; border-right: 1px solid #eceff4;">
                  <span class="compnaylogoplaceholder">
                    <img [src]="item.companylogo" class="img-fluid" *ngIf="item.companylogo" alt="company name">
                    <i class="fas fa-building f-12" *ngIf="!item.companylogo"></i>
                  </span>

                </div>
                <div class="d-grid" (mouseenter)="getCompanyInfo(item)"
                  [ngClass]="{companyHover: item?.website, 'dstooltip pointer':item?.website}"
                  style="margin-left: 24px;">
                  <span> {{item.label}} </span>
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                  </span>
                </div>
              </div>
            </div>
            <div class="col f-14 d-flex align-items-center  font-weight-600">
              <span class="pointer" (click)="handleRedirection('company', { key: item.label, doc_count: item.value, companylogo: item.companylogo })">{{item.value | number:'1.0':'en-US'}}</span>
            </div>
          </div>
        </ng-container>
        </div>
    </div>
    <div class="col">
      <div class="row mb-3 mt-3">
        <div class="col-md-9 f-12 text-9696">
          Top Industries
        </div>
        <div class="col f-12 text-9696">
          Talent Count
        </div>
      </div>

      <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.currentIndustry?.length">
        <img *ngIf="!personInsightsData.currentIndustry" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.currentIndustry?.length == 0">No Data Available</span>
      </div>

      <ng-container *ngIf="personInsightsData?.currentIndustry?.length">
        <div class="row mb-2" *ngFor="let industry of personInsightsData?.currentIndustry">
          <div class="col-md-9">
            <div class="d-flex p-2 w-100">
              <div style="width: 50px; border-right: 1px solid #eceff4;">
                <div class="building-icon bg-gray-new">
                  <i [class]="getIndustryIcon(industry?.key)"></i>
                </div>
              </div>
              <div style="margin-left: 24px;" class="d-grid" [matTooltip]="industry.key | titlecase"
                [matTooltipClass]="{ 'red-tooltip text-black': true }">
                <span class="text-truncate">{{industry.key | titlecase}}</span>
              </div>
            </div>
          </div>
          <div class="col f-14 d-flex align-items-center font-weight-600">
            <span class="pointer" (click)="handleRedirection('industry', industry)">{{industry.doc_count | number}}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <hr class="HR-seperator-in-card mb-4">

  <!-- Top schools - field of study -->
  <p class="f-16 font-weight-600 mb-3"> What educational background does the talent have?</p>
  <div class="row">
    <div class="col">
      <div class="row mb-3">
        <div class="col-md-9 f-12 text-9696">
          Top Colleges
        </div>
        <div class="col f-12 text-9696 d-flex align-items-center">
          Talent Count
        </div>
      </div>
      <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.school?.length">
        <img *ngIf="!personInsightsData.school" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.school?.length == 0">No Data Available</span>
      </div>
      <ng-container *ngIf="personInsightsData?.school?.length">
        <div class="test" *ngFor="let s of personInsightsData?.school">
          <div class="row">
            <div class="col-md-9 d-grid">
              <span class="text-truncate">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-600">
              <span class="pointer" (click)="handleRedirection('school', s)">
                {{s.doc_count | number}}
              </span>
            </div>
          </div>
          <hr class="HR-seperator-in-card mb-4 mx-0">
        </div>
      </ng-container>
    </div>
    <div class="col">
      <div class="row mb-3">
        <div class="col-md-9 f-12 text-9696">
          Fields of Study
        </div>
        <div class="col f-12 text-9696">
          Talent Count
        </div>
      </div>
      <div class="loader text-center" *ngIf="!personInsightsData?.fieldOfStudy?.length">
        <img *ngIf="!personInsightsData.fieldOfStudy" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.fieldOfStudy?.length == 0">No Data Available</span>
      </div>
      <ng-container *ngIf="personInsightsData?.fieldOfStudy?.length">
        <div class="test" *ngFor="let fs of personInsightsData?.fieldOfStudy">
          <div class="row">
            <div class="col-md-9 d-grid">
              <span class="text-truncate">{{fs.key | titlecase}}</span>
            </div>
            <div class="col font-weight-600">
              <span class="pointer" (click)="handleRedirection('fieldofstudy', fs)">{{fs.doc_count | number}}</span>
            </div>
          </div>
          <hr class="HR-seperator-in-card mb-4 mx-0">
        </div>
      </ng-container>
    </div>
  </div>
  <hr class="HR-seperator-in-card mb-4">

  <p class="f-16 font-weight-600 mb-3"> What titles and skills does this talent have? </p>
  <div class="row">
    <div class="col">
      <div class="row mb-3">
        <div class="col-md-9 f-12 text-9696">
          Top Skills
        </div>
        <div class="col f-12 text-9696">
          Talent Count
        </div>
      </div>
      <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.skills?.length">
        <img *ngIf="!personInsightsData.skills" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.skills?.length == 0">No Data Available</span>
      </div>
      <ng-container *ngIf="personInsightsData?.skills?.length">
        <div class="test" *ngFor="let s of personInsightsData?.skills">
          <div class="row">
            <div class="col-md-9 d-grid">
              <span class="text-truncate">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-600">
              <span class="pointer" (click)="handleRedirection('skills', s)">
                {{s.doc_count | number}}
              </span>
            </div>
          </div>
          <hr class="HR-seperator-in-card mb-4 mx-0">
        </div>
      </ng-container>
    </div>
    <div class="col">
      <div class="row mb-3">
        <div class="col-md-9 f-12 text-9696">
          Top Titles
        </div>
        <div class="col f-12 text-9696">
          Talent Count
        </div>
      </div>
      <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.titles?.length">
        <img *ngIf="!personInsightsData.titles" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.titles?.length == 0">No Data Available</span>
      </div>
      <ng-container *ngIf="personInsightsData?.titles?.length">
        <div class="test" *ngFor="let t of personInsightsData?.titles">
          <div class="row">
            <div class="col-md-9 d-grid">
              <span class="text-truncate">{{t.key | titlecase}}</span>
            </div>
            <div class="col font-weight-600">
              <span class="pointer" (click)="handleRedirection('jobtitle', t)">
                {{t.doc_count | number}}
              </span>
            </div>
          </div>
          <hr class="HR-seperator-in-card mb-4 mx-0">
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Overall and Current exp -->
<div class="d-flex mt-2 mb-2 flex-column wccard">
  <p class="f-16 font-weight-600 pl-3 mb-0 pt-3">How long has the talent been working?
  </p>
  <div class="d-flex">
    <div class="col position-relative  wccard">
      <p class="f-12 pt-4 font-weight-normal text-9696 px-3"> Overall Tenure </p>
      <div class="col position-relative my-2">
        <div class="loader h-23 center-content d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.dataSourceCurrentExperience?.data?.length">
          <img *ngIf="!personInsightsData.dataSourceCurrentExperience" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.dataSourceCurrentExperience?.data?.length == 0">No Data Available</span>
        </div>
        <fusioncharts width="100%" height="450" type="column2d" [dataSource]="personInsightsData?.dataSourceCurrentExperience" (dataplotClick)="fusionChartsClickHandler($event, 'yearsofexperience')"
          *ngIf="personInsightsData?.dataSourceCurrentExperience && personInsightsData?.dataSourceCurrentExperience?.data?.length">
        </fusioncharts>
      </div>
    </div>

    <div class="col position-relative wccard">
      <p class="f-12 pt-4 font-weight-normal text-9696 px-3"> Tenure in Current Company </p>
      <div class="col wccard">
        <div class="loader h-23 center-content d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.dataSourceExpInCurrentRole?.data?.length">
          <img *ngIf="!personInsightsData.dataSourceExpInCurrentRole" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.dataSourceExpInCurrentRole?.data?.length == 0">No Data Available</span>
        </div>
        <fusioncharts width="100%" height="450" type="column2d" [dataSource]="personInsightsData?.dataSourceExpInCurrentRole" (dataplotClick)="fusionChartsClickHandler($event, 'currentyearsofexperience')"
          *ngIf="personInsightsData?.dataSourceExpInCurrentRole && personInsightsData?.dataSourceExpInCurrentRole?.data?.length">
        </fusioncharts>
      </div>
    </div>
  </div>
</div>


<!-- This section hides because of complience issues -->
<!-- <div class="d-flex">


  <div class="wccard p-3" style="margin: 0px 8px 8px 0px; width: 50%;">
    <div class="f-16 font-weight-600">What is the talent’s nationality?</div>
    <div class="loader text-center align-content-center" style="height: 100%; min-height: 400px;" *ngIf="!personInsightsData?.dataSourceNationality?.data?.length">
      <img *ngIf="!personInsightsData?.dataSourceNationality" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      <span *ngIf="personInsightsData?.dataSourceNationality?.data?.length == 0">No Data Available</span>
    </div>
    <div *ngIf="personInsightsData?.dataSourceNationality?.data?.length">
      <fusioncharts type="bar2d" [dataSource]="personInsightsData?.dataSourceNationality"></fusioncharts>
      <p class="mb-0 f-10 line-height-1 text-484b59">
        <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
      </p>
    </div>
  </div>


  <div class="wccard p-3" style="margin-bottom: 8px; width: 50%;">
    <div class="f-16 font-weight-600">What is the talent’s ethnicity?</div>
    <div class="loader text-center align-content-center" style="height: 100%; min-height: 400px;" *ngIf="!personInsightsData?.dataSourceEthnicity?.data?.length">
      <img *ngIf="!personInsightsData?.dataSourceEthnicity" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      <span *ngIf="personInsightsData?.dataSourceEthnicity?.data?.length == 0">No Data Available</span>
    </div>
    <div *ngIf="personInsightsData?.dataSourceEthnicity?.data?.length">
      <fusioncharts width="100%" type="doughnut2d" [dataSource]="personInsightsData?.dataSourceEthnicity"></fusioncharts>
      <p class="mb-0 f-10 line-height-1 text-484b59">
        <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
      </p>
    </div>
  </div>
</div> -->


<!-- Diversity & Seniority -->
<div class="d-flex mb-2">
  <div class="col position-relative wccard mr-2 p-3">
    <p class="mb-2 f-16 font-weight-600"> What's the talent's gender diversity?
    </p>
    <div class="center-content">
      <div class="loader center-content h-23" *ngIf="!personInsightsData?.dataSourceGender?.data?.length">
        <img *ngIf="!personInsightsData.dataSourceGender" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.dataSourceGender?.data?.length == 0">No Data Available</span>
      </div>
      <fusioncharts type="doughnut2d" [dataSource]="personInsightsData?.dataSourceGender" style="pointer-events: none;"
        *ngIf="personInsightsData?.dataSourceGender && personInsightsData?.dataSourceGender?.data?.length">
      </fusioncharts>
    </div>
  </div>

  <div class="col position-relative wccard p-3">
    <p class="mb-2 f-16 font-weight-600">What level of seniority does the talent have? </p>
    <!-- <div class="wccard center-content"> -->
      <div class="loader center-content h-23 d-flex align-items-center justify-content-center" *ngIf="!personInsightsData?.dataSourceSeniority?.data?.length">
        <img *ngIf="!personInsightsData.dataSourceSeniority" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        <span *ngIf="personInsightsData?.dataSourceSeniority?.data?.length == 0">No Data Available</span>
      </div>
      <fusioncharts type="bar2d" [dataSource]="personInsightsData?.dataSourceSeniority"
        *ngIf="personInsightsData?.dataSourceSeniority && personInsightsData?.dataSourceSeniority?.data?.length">
      </fusioncharts>
    <!-- </div> -->
  </div>
</div>
